import {useNavigate} from "react-router-dom";
import sharedStyle from "./YoutubeShared.module.css";
import homeIcon from "../../assets/home-icon.svg";
import mainImg from "../../assets/youtube-kids-images/blocco-video.png";

function BloccoVideo() {
    const navigate = useNavigate();

    function navigateHandler() {
        navigate('/youtube-kids')
    }
    return (
        <div className={sharedStyle.mainContainer}>
            <img
                src={homeIcon}
                alt={'icon'}
                className={'img-home'}
                onClick={navigateHandler}
            />
            <div className={sharedStyle.infoContainer}>
                <div className={sharedStyle.textContainerLeft}>
                    <h1
                        className={sharedStyle.textTitle}
                    >
                        Un modo semplice per bloccare i video.
                    </h1>
                    <h3>
                        Non ti piace un video? Blocca il video o l'intero canale e non lo vedrai mai più.
                    </h3>
                </div>
            </div>
            <div className={sharedStyle.imgContainer}>
                <img src={mainImg} alt={''} className={sharedStyle.imgMain}/>
            </div>
            <div className={'img-free-container'}>

            </div>
        </div>
    )
}

export default BloccoVideo;